var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "service-container"
  }, [_c('div', {
    staticClass: "video_wrap"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('h2', {
    staticClass: "media_font_size_70"
  }, [_vm._v(_vm._s(_vm.$t("homepage.exhibitionName")))])]), _vm._v(" "), _c('video', {
    attrs: {
      "src": "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/gz_2024.m4v",
      "controls": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "news_wrap"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('h2', {
    staticClass: "media_font_size_70"
  }, [_vm._v(_vm._s(_vm.$t("homepage.notice")))])]), _vm._v(" "), _c('div', {
    staticClass: "news_container"
  }, _vm._l((_vm.noticeList), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "news_item",
      on: {
        "click": function($event) {
          return _vm.handelJump('/newsCenter?tab=0&noticeId=' + item.noticeId)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": item.img,
        "alt": ""
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "item_title media_font_size_50"
    }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('span', {
      staticClass: "item_date media_font_size_30"
    }, [_vm._v(_vm._s(item.date))])])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "default_btn media_font_size_50",
    on: {
      "click": function($event) {
        return _vm.handelJump('/newsCenter?tab=0')
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.noticeList.length > 0 ? _vm.$t("public.more") : _vm.$t("public.nomore")))])])]), _vm._v(" "), _c('div', {
    staticClass: "news_wrap"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('h2', {
    staticClass: "media_font_size_70"
  }, [_vm._v(_vm._s(_vm.$t("homepage.news")))])]), _vm._v(" "), _c('div', {
    staticClass: "news_container"
  }, _vm._l((_vm.newsList), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "news_item",
      on: {
        "click": function($event) {
          return _vm.handelJump('/newsCenter?tab=1&newsId=' + item.newsId)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": item.img,
        "alt": ""
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "item_title media_font_size_50"
    }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('span', {
      staticClass: "item_date media_font_size_30"
    }, [_vm._v(_vm._s(item.date))])])
  }), 0), _vm._v(" "), (_vm.newsList.length > 0) ? _c('div', {
    staticClass: "default_btn media_font_size_50",
    on: {
      "click": function($event) {
        return _vm.handelJump('/newsCenter?tab=1')
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.noticeList.length > 0 ? _vm.$t("public.more") : _vm.$t("public.nomore")))])]) : _vm._e()]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "co_wrap"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('h2', {
    staticClass: "media_font_size_70"
  }, [_vm._v(_vm._s(_vm.$t("homepage.coMedia")))])]), _vm._v(" "), _c('div', {
    staticClass: "swiper-container coswiper"
  }, [_c('swiper', {
    ref: "mySwiper",
    staticClass: "swiper",
    attrs: {
      "options": _vm.swiperOption
    }
  }, _vm._l((_vm.logoList), function(item, index) {
    return _c('swiper-slide', {
      key: index,
      staticClass: "slide"
    }, [_c('img', {
      attrs: {
        "src": item.img,
        "alt": ""
      }
    })])
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "default_btn media_font_size_50",
    on: {
      "click": function($event) {
        return _vm.handelJump('/friendlyLink?tab=2')
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t("public.more")))])])])])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "map_wrap"
  }, [_c('img', {
    attrs: {
      "src": "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/map.png",
      "alt": ""
    }
  })])
}]
export default { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-05da5757","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/home/components/service.vue
// module id = null
// module chunks = 